import { DeviceGeneralStatus } from '@cobliteam/api-lib/src/__generated__/graphql';

const statusIconName = {
  [DeviceGeneralStatus.Normal]: 'cb-signal-cellular-4',
  [DeviceGeneralStatus.Syncing]: 'rotate-cw',
  [DeviceGeneralStatus.NoSignal]: 'cb-signal-cellular-off',
  [DeviceGeneralStatus.Disconnected]: 'cb-unplugged',
  [DeviceGeneralStatus.Unavailable]: 'cb-device-status-indicators-unavailable-indicator',
  [DeviceGeneralStatus.NoSufficientData]: null,
  [DeviceGeneralStatus.LosingData]: 'cb-device-status-indicators-lost-data',
  [DeviceGeneralStatus.InDevolution]: 'undo-2',
  [DeviceGeneralStatus.Damaged]: 'lock-keyhole',
};

const statusColors = {
  [DeviceGeneralStatus.Normal]: 'text-primary bg-primary-3',
  [DeviceGeneralStatus.Syncing]: 'text-primary-4 bg-primary-3',
  [DeviceGeneralStatus.NoSignal]: 'text-gray-dark bg-gray-3',
  [DeviceGeneralStatus.Disconnected]: 'text-warning bg-warning-3',
  [DeviceGeneralStatus.Unavailable]: 'text-danger bg-danger-3',
  [DeviceGeneralStatus.NoSufficientData]: 'text-gray bg-transparent',
  [DeviceGeneralStatus.LosingData]: 'text-white bg-danger-dark',
  [DeviceGeneralStatus.InDevolution]: 'text-accessory-2 bg-accessory-2/10',
  [DeviceGeneralStatus.Damaged]: 'text-white bg-danger-dark',
};

const statusLabel = {
  [DeviceGeneralStatus.Normal]: 'normal',
  [DeviceGeneralStatus.Syncing]: 'sincronizando',
  [DeviceGeneralStatus.NoSignal]: 'sem sinal',
  [DeviceGeneralStatus.Disconnected]: 'desconectado',
  [DeviceGeneralStatus.Unavailable]: 'indisponível',
  [DeviceGeneralStatus.NoSufficientData]: 'Sem dados suficientes',
  [DeviceGeneralStatus.LosingData]: 'perdendo dados',
  [DeviceGeneralStatus.InDevolution]: 'em devolução',
  [DeviceGeneralStatus.Damaged]: 'danificado',
};

const tooltipLabel = {
  [DeviceGeneralStatus.Normal]: 'O dispositivo está saudável e mostrando informações mais recentes.',
  [DeviceGeneralStatus.Syncing]: 'O dispositivo está saudável e novas informações estão sendo descarregadas no painel.',
  [DeviceGeneralStatus.NoSignal]:
    'As informações sobre o veículo estão desatualizadas mas o dispositivo continua registrando dados enquanto estabiliza para sincronizá-los com o painel.',
  [DeviceGeneralStatus.Disconnected]: 'O dispositivo foi retirado do veículo. A última tensão da bateria do veículo registrada pelo dispositivo está abaixo dos 10v.',
  [DeviceGeneralStatus.Unavailable]: 'Não recebemos atualização há mais de 72 horas e algumas ações precisam ser tomadas.',
  [DeviceGeneralStatus.NoSufficientData]: 'Dispositivo sem dados suficientes',
  [DeviceGeneralStatus.LosingData]: 'Dispositivo rodando sem veículo associado e perdendo dados.',
  [DeviceGeneralStatus.InDevolution]: 'Dispositivo em processo de devolução.',
  [DeviceGeneralStatus.Damaged]:
    'Através de diagnósticos remotos e automáticos feitos nos dispositivos conseguimos identificar quando há uma quantidade de mensagens inválidas que inviabilizam o seu uso.',
};

const getStatusContent = (status: DeviceGeneralStatus) => {
  const iconName = statusIconName[status];
  const colors = statusColors[status];
  const label = statusLabel[status];
  const tooltip = tooltipLabel[status];

  return {
    iconName,
    colors,
    label,
    tooltip,
  };
};

export default getStatusContent;
